import { QueryClient } from "@tanstack/react-query";

/**
 * Centralized React Query client configuration
 * - Caches data to reduce redundant API calls
 * - Configures stale time, retry logic, and error handling
 * - Optimized for performance with longer cache times
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 10 minutes (no refetch on component remount)
      staleTime: 10 * 60 * 1000,
      // Keep unused data in cache for 30 minutes
      gcTime: 30 * 60 * 1000,
      // Retry failed requests 2 times with exponential backoff
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Don't refetch on window focus by default (can override per-query)
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
      // Use cached data while fetching fresh data in background
      refetchOnMount: false,
      // Optimize for better performance
      networkMode: "online", // Only run when online
    },
    mutations: {
      // Retry mutations once on network errors
      retry: 1,
      networkMode: "online",
    },
  },
});
